// extracted by mini-css-extract-plugin
export default {"divMain":"MiniProduct_divMain__2t7WL","active":"MiniProduct_active__wdGdG","divMainWrapper":"MiniProduct_divMainWrapper__-m-s6"};